@if (isSwissTimingEnabled) {
	<vb-lxp-swiss-timing-iframe></vb-lxp-swiss-timing-iframe>
}
	
@else {
	<vb-lxp-timing-tower-configurable
		[config]="config"
		[enableColumnCustomization]="enableColumnCustomization()"
		[hideColumnSelection]="hideColumnSelection()"
		[activeClass]="activeClass()"
		[activeNumberClass]="activeNumberClass()"
		[selectedClasses]="selectedClasses()"
	/>
}

